<div class="row">
    <div class="col">
      <button class='btn btn-info' (click)='newQuote()'>New Quote</button>
    </div>
  </div>
  
  <div class="bg-primary pb-3">
    <app-grid
      entity='quote'
      [filters]='this.filters'
      [columns]='this.columns'
      [buttons]='this.buttons'
      [toolbarButtons]='this.toolbarButtons'
      [searchFilters]='this.searchFilters'
      [searchFields]='this.searchFields'
  ></app-grid>
  </div>